import axios from 'utils/axios';

export const createPatientServicePackagePaymentUrl = (patientServicePackageId: string, amountRub: number, description?: string) => {
  return axios.post(`/api/v1/transactions/${patientServicePackageId}/payment`, {
    amountRub: amountRub,
    description: description
  });
};
